import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Bmob from 'hydrogen-js-sdk'

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

// Bmob.initialize('3eb597d06089f564', 'hmmapp')
Bmob.initialize('158633f0a5869f24', 'yjmapp')
Vue.prototype.Bmob = Bmob
